import { render } from "./service_detail.vue?vue&type=template&id=1afb03d9"
import script from "./service_detail.vue?vue&type=script&lang=js"
export * from "./service_detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__